export function resetCaptcha() {
    try {
        if (window['grecaptcha']) window['grecaptcha'].reset()
    } catch {}
}
